
import apis from "."; // Import your API instance or base URL setup

export async function displayCart(token) {
  try {
    const result = await apis.get("/display-cart", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return result;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
}

export async function removeFromCart(productId, productCode, token) {
  try {
    const result = await apis.post(
      "/remove-from-cart",
      { productId, productCode },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return result;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
}

export async function addToCart(productID, productCode, quantity, token) {
  try {
    const result = await apis.post(
      "/add-to-cart",
      { productID, productCode, quantity }, 
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return result;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
}

export async function editCart(productID, productCode, newAmount, token) {
  try {
    const result = await apis.post("/edit-card",{ productID, productCode,newAmount }, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return result;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
}
